/** Filipino: Workflows (M29, BOT-005): mga test case, tatlong takbo at ang gate bago mag-publish. Isinasama sa `engage.workflows.regression`. */
export const workflowsRegression = {
  tab: "Mga test",
  title: "Mga test case",
  intro: "I-save ang mga usapang dapat kayanin ng flow na ito. Patakbuhin nang tatlong beses: ang flow na may test case ay mapa-publish lang kapag pumasa ang huling takbo.",
  add: "Magdagdag ng test case",
  run: "Patakbuhin nang 3 beses",
  running: "Tumatakbo…",
  runStarted: "Tumatakbo ang mga case.",
  saved: "Na-save ang test case.",
  deleted: "Natanggal ang test case.",
  limit: "{{count}} test case ang pinakamarami sa isang workflow. Magtanggal ng isa para makapagdagdag.",
  empty: {
    title: "Wala pang test case",
    body: "Ilarawan kung ano ang isinusulat ng customer at ano ang dapat gawin ng flow. Tatakbo ang mga case nang tatlong beses bago ma-publish ang flow.",
  },
  loadFailed: "Hindi ma-load ang mga test case.",
  list: {
    messages_one: "{{count}} mensahe ng customer",
    messages_other: "{{count}} mensahe ng customer",
    customer: "Customer: {{details}}",
    path: "Aabot sa {{path}}",
    handoverYes: "Ipapasa sa tao",
    handoverNo: "Hindi ipapasa sa tao",
    contains: "May sagot na: {{words}}",
    edit: "I-edit ang {{name}}",
    delete: "Tanggalin ang {{name}}",
    deleteTitle: "Tanggalin ang test case na ito?",
    deleteBody: "Aalisin ang “{{name}}”. Hindi na ito susuriin ng susunod na takbo.",
    confirmDelete: "Tanggalin ang test case",
  },
  form: {
    addTitle: "Magdagdag ng test case",
    editTitle: "I-edit ang test case",
    description: "Ang unang mensahe ang magsisimula ng flow; ang mga susunod ay sagot sa tinatanong nito (button ayon sa label, o isang value).",
    name: "Pangalan",
    messages: "Mga mensahe ng customer (isa bawat linya)",
    messagesHint: "Dapat tumugma ang unang linya sa mga salitang nagsisimula ng flow na ito.",
    tier: "Tier ng customer",
    status: "Status ng account",
    attributes: "Iba pang detalye ng customer (key=value, isa bawat linya)",
    attributesHint: "Halimbawa kyc_status=pending. Maliliit na letra, numero at underscore ang key.",
    path: "Dapat maabot ang path na ito",
    pathHint: "Titik ng path (B) o ang pangalan nito.",
    handover: "Ipapasa sa tao",
    handoverAny: "Hindi susuriin",
    handoverYes: "Oo",
    handoverNo: "Hindi",
    contains: "Dapat taglay ng mga sagot ng flow (isa bawat linya)",
    save: "I-save ang test case",
    cancel: "Kanselahin",
    problems: {
      name: "Bigyan ng pangalan ang test case.",
      messages: "Magsulat ng kahit isang mensahe ng customer.",
      attributes: "Isulat ang bawat detalye bilang key=value na maliit ang letra ng key.",
      expected: "Pumili ng kahit isang susuriin: path, handover o mga salita sa sagot.",
    },
  },
  run_state: {
    never: "Hindi pa napatakbo",
    running: "Pinatatakbo ang mga case…",
    passed: "Pumasa ang lahat ng {{count}} takbo",
    failed: "Bumagsak",
    stale: "Pumasa, pero nagbago ang draft o ang mga case mula noon. Patakbuhin muli.",
    error: "Hindi natapos ang takbo. Patakbuhin muli.",
  },
  results: {
    title: "Huling takbo",
    case: "Test case",
    outcome: "Resulta",
    passed: "Pumasa ang {{passed}} sa {{total}} takbo",
    runPassed: "Pumasa ang takbo {{n}}",
    runFailed: "Bumagsak ang takbo {{n}}",
    failure: {
      not_started: "Hindi nagsimula ang flow sa unang mensahe",
      path_not_reached: "Hindi naabot ang path",
      handover_mismatch: "Iba ang handover sa inaasahan",
      answer_missing: "Wala sa mga sagot ang mga salita",
      stuck: "Hindi natapos ang flow sa takdang oras",
      error: "Hindi mapatakbo ang flow",
    },
    removed: "Case na natanggal na",
  },
  publish: {
    title: "Naka-hold ang pag-publish dahil sa mga test case",
    why: {
      no_run: "Hindi pa napatakbo ang mga test case na ito.",
      running: "Tumatakbo pa ang mga test case.",
      failed: "Bumagsak ang huling takbo ng mga test case.",
      stale: "Nagbago ang draft o ang mga test case pagkatapos ng huling takbo.",
    },
    body: "Patakbuhin ang mga test case nang tatlong beses. Kapag pumasa lahat, i-publish.",
    runAgain: "Patakbuhin nang 3 beses",
    publish: "I-publish",
    published: "Na-publish ang bersyon {{version}}.",
    close: "Isara",
    overrideTitle: "I-publish pa rin",
    overrideBody: "Kailangan ang pahintulot na mag-override sa pag-publish. Itatala sa audit log ang dahilan ninyo.",
    reason: "Dahilan",
    reasonHint: "Sabihin kung bakit lalabas ang bersyong ito nang walang pumasang takbo.",
    reasonMissing: "Isulat muna ang dahilan.",
    overrideConfirm: "I-publish nang walang pumasang takbo",
    overridden: "Na-publish nang may override. Nakatala ito sa audit log.",
    noOverride: "Miyembro lang na may pahintulot na mag-override ang makakapag-publish nang walang pumasang takbo.",
  },
};
